/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_BlockedInputs */

const en_directory_agent_readiness_status_blocked = /** @type {(inputs: Directory_Agent_Readiness_Status_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspection blocked`)
};

const zh_directory_agent_readiness_status_blocked = /** @type {(inputs: Directory_Agent_Readiness_Status_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查受到访问限制`)
};

/**
* | output |
* | --- |
* | "Inspection blocked" |
*
* @param {Directory_Agent_Readiness_Status_BlockedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_blocked = /** @type {((inputs?: Directory_Agent_Readiness_Status_BlockedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_BlockedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_blocked(inputs)
	return zh_directory_agent_readiness_status_blocked(inputs)
});
export { directory_agent_readiness_status_blocked as "directory.agent_readiness.status.blocked" }